import React from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import { Input, InputPhone } from 'components';
import './style.scss';

export const Step2 = () => (
  <Layout className="team-registration__step-2">
    <Row>
      <Col>
        <Typography.Title className="step-name" level={4}>
          Contact information
        </Typography.Title>
      </Col>
    </Row>
    <Row gutter={8}>
      <Col sm={24} md={12}>
        <Input
          name="first_name"
          label="First name"
          rules={[
            { required: true, message: 'Enter first name' },
            {
              validator(_, value) {
                if (value && !value.trim()) return Promise.reject(new Error('Enter first name'));
                return Promise.resolve();
              },
            },
            { min: 1, max: 50, message: 'Must be 1–50 characters' },
          ]}
        />
      </Col>
      <Col sm={24} md={12}>
        <Input
          name="last_name"
          label="Last name"
          rules={[
            { required: true, message: 'Enter last name' },
            {
              validator(_, value) {
                if (value && !value.trim()) return Promise.reject(new Error('Enter last name'));
                return Promise.resolve();
              },
            },
            { min: 1, max: 50, message: 'Must be 1–50 characters' },
          ]}
        />
      </Col>
    </Row>
    <Row gutter={8}>
      <Col sm={24} md={{ flex: '1' }}>
        <Input
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Enter email' },
            { type: 'email', message: 'Invalid email format' },
          ]}
          formItemProps={{
            normalize: (value) => value.replace(/[^a-zA-Z0-9@._%+-]/g, ''),
          }}
        />
      </Col>
      <Col sm={24} md={{ flex: '168px' }}>
        <InputPhone
          name="primary_contact"
          label="Mobile Phone"
          rules={[
            { required: true, message: 'Enter mobile phone' },
            {
              pattern: /^\D*(\d\D*){10}$/,
              message: 'Format: (123) 456-7890',
            },
          ]}
        />
      </Col>
    </Row>
  </Layout>
);
